import { useEffect, useState } from "react";
import { Alert, ScrollView, View } from "react-native";
import CustomText from "../accessories/CustomText";
import { InputBox, ModalButton, Separator } from "../accessories/accessories";
import FontAwesome from "react-native-vector-icons/FontAwesome";
import { handleAPI } from "../accessories/CommonFunctions";
import XMLParser from "react-xml-parser";
import { web } from "../accessories/Platform";

const ChangePassword = (props) => {
  const { WebLoginId, closeModal } = props;
  const [passwordMisMatch, setPasswordMisMatch] = useState("");
  const [newPasswordMessage, setNewPasswordMessage] = useState({
    passwordMsg: "",
    confirmPasswordMsg: "",
  });

  const [newPassword, setNewPassword] = useState({
    password: "",
    confirmPassword: "",
  });

  const [newIsPasswordSecure, setNewIsPasswordSecure] = useState({
    password: true,
    confirmPassword: true,
  });
  const [errorMessage, setErrorMessage] = useState({
    text: "",
    color: "red",
  });
  const validatePassword = (key, text) => {
    setPasswordMisMatch("");
    setNewPassword({ ...newPassword, ...{ [key]: text, key: key } });
  };

  useEffect(() => {
    let strength = 0,
      key = newPassword["key"],
      text = newPassword[key];
    if (text !== undefined) {
      if (text.length > 6) strength += 1;
      if (text.match(/([A-Z])/) && text.match(/([0-9])/)) strength += 1;
      if (text.match(/([!,%,&,@,#,jQuery,^,*,?,_,~])/)) strength += 1;
      let msg = ``;
      if (strength < 3) {
        msg = `Password does not meet complexity Requirements.`;
      } else {
        msg = `Password Meets Complexity Requirements`;
      }
      if (key === "confirmPassword" && text !== newPassword["password"]) {
        msg = `Password Does Not Match`;
        strength = 0;
      }
      if (
        (newPassword["password"] === "" && key === "password") ||
        (newPassword["confirmPassword"] === "" && key === "confirmPassword")
      ) {
        msg = "";
      } else {
        msg = (
          <View style={{ marginTop: -10, marginBottom: 10 }}>
            <FontAwesome
              name={strength < 3 ? "close" : "check"}
              size={22}
              color={strength < 3 ? "red" : "green"}
            />
            <CustomText
              bold={true}
              style={{
                color: "#999",
                marginTop: -20,
                marginBottom: 20,
                fontSize: 14,
                marginLeft: 30,
              }}
            >
              {msg}
            </CustomText>
          </View>
        );
      }
      setNewPasswordMessage({ ...newPasswordMessage, [`${key}Msg`]: msg });
    }
  }, [newPassword]);

  return (
    <ScrollView>
      <View
        style={[
          { marginHorizontal: 10 },
          // web
          //   ? { width: 750, right: 0, position: "absolute", height: "100%" }
          //   : {},
        ]}
      >
        <CustomText
          style={{
            fontSize: 15,
            color: "#999",
            marginBottom: 30,
          }}
        >
          <CustomText bold={true} style={{ color: "#999" }}>
            Password Requirements:
          </CustomText>{" "}
          Minimum length of 6 characters Must contain 1 number, 1 capital
          letter, and 1 special character such as: (@!*&).
        </CustomText>
        <View>
          <View>
            <InputBox
              label="Password"
              autoFocus
              type="default"
              secureTextEntry={newIsPasswordSecure["password"]}
              placeholder="Please enter your password..."
              onChangeText={(text) => {
                validatePassword("password", text);
              }}
              value={newPassword["password"]}
              border="#333"
            />

            <CustomText
              style={{
                position: "absolute",
                right: 20,
                top: 15,
              }}
              onPress={() => {
                setNewIsPasswordSecure({
                  ...newIsPasswordSecure,
                  password: !newIsPasswordSecure["password"],
                });
              }}
            >
              {newIsPasswordSecure["password"] ? (
                <FontAwesome name="eye" color="gray" size={25} />
              ) : (
                <FontAwesome name="eye-slash" color="gray" size={25} />
              )}
            </CustomText>
            {newPasswordMessage["passwordMsg"] !== "" &&
              newPassword["password"] !== "" && (
                <>{newPasswordMessage["passwordMsg"]}</>
              )}
          </View>
          <View>
            <InputBox
              label="Confirm Password"
              type="default"
              secureTextEntry={newIsPasswordSecure["confirmPassword"]}
              placeholder="Confirm your password..."
              onChangeText={(text) => {
                validatePassword("confirmPassword", text);
              }}
              value={newPassword["confirmPassword"]}
              border="#333"
            />
            <CustomText
              style={{
                position: "absolute",
                right: 20,
                top: 15,
              }}
              onPress={() => {
                setNewIsPasswordSecure({
                  ...newIsPasswordSecure,
                  confirmPassword: !newIsPasswordSecure["confirmPassword"],
                });
              }}
            >
              {newIsPasswordSecure["confirmPassword"] ? (
                <FontAwesome name="eye" color="gray" size={25} />
              ) : (
                <FontAwesome name="eye-slash" color="gray" size={25} />
              )}
            </CustomText>
            {newPasswordMessage["confirmPasswordMsg"] !== "" &&
              newPassword["confirmPassword"] !== "" && (
                <>{newPasswordMessage["confirmPasswordMsg"]}</>
              )}
            {errorMessage["text"] !== "" && (
              <CustomText
                bold={true}
                italic={errorMessage["italic"] === undefined ? true : false}
                style={[
                  styles.errorMessage,
                  {
                    color: errorMessage["color"] || "red",
                    marginTop: -5,
                    marginBottom: 0,
                  },
                ]}
              >
                {errorMessage["text"]}
              </CustomText>
            )}
          </View>
          <View
            style={{
              flexDirection: "row",
              justifyContent: "flex-end",
            }}
          >
            <ModalButton
              onPress={() => {
                if (newPassword["password"] === "") {
                  setPasswordMisMatch("Please enter the New Password.");
                  return false;
                }
                if (newPassword["confirmPassword"] === "") {
                  setPasswordMisMatch("Please enter the Confirm New Password.");
                  return false;
                }
                if (
                  newPassword["confirmPassword"] !== newPassword["password"]
                ) {
                  setPasswordMisMatch(
                    "The new password and confirmed password do not match."
                  );
                  return false;
                }

                let strength = 0,
                  text = newPassword["password"];
                if (text.length > 6) strength += 1;
                if (text.match(/([A-Z])/) && text.match(/([0-9])/))
                  strength += 1;
                if (text.match(/([!,%,&,@,#,jQuery,^,*,?,_,~])/)) strength += 1;
                if (strength < 3) {
                  setPasswordMisMatch(
                    `Password does not meet minimum complexity requirements, password must contain: 
Minimum length of 6 characters 
Must contain 1 number, 1 capital letter, and 1 special character such as: (@!*&)`
                  );
                  return false;
                }
                strength = 0;
                text = newPassword["confirmPassword"];
                if (text.length > 6) strength += 1;
                if (text.match(/([A-Z])/) && text.match(/([0-9])/))
                  strength += 1;
                if (text.match(/([!,%,&,@,#,jQuery,^,*,?,_,~])/)) strength += 1;
                if (strength < 3) {
                  setPasswordMisMatch(
                    `Password does not meet minimum complexity requirements, password must contain: 
Minimum length of 6 characters 
Must contain 1 number, 1 capital letter, and 1 special character such as: (@!*&)`
                  );
                  return false;
                }
                if (
                  newPassword["password"] === newPassword["confirmPassword"]
                ) {
                  console.log({
                    WebLoginId,
                    Password: newPassword["password"],
                  });
                  handleAPI({
                    name: "SavePasswordRedirect",
                    params: {
                      WebLoginId,
                      Password: newPassword["password"],
                    },
                  }).then((response) => {
                    console.log(response);
                    response =
                      JSON.parse(response)["Table"][0]["Column1"].toString();
                    response = new XMLParser().parseFromString(response)[
                      "children"
                    ][0]["attributes"];
                    let msg = response["Message"];
                    setErrorMessage({ text: "" });
                    if (msg === "Password updated successfully.") {
                      closeModal(msg);
                    } else setPasswordMisMatch(msg);
                  });
                }
              }}
              icon={true}
              title={`Save`}
              style={{ marginBottom: 10, color: "#fff" }}
            />
          </View>
          {passwordMisMatch !== "" && (
            <View
              style={{
                borderWidth: 1,
                borderColor: "#ebccd1",
                backgroundColor: "#f2dede",
                borderRadius: 5,
                marginBottom: 10,
              }}
            >
              <CustomText
                style={{
                  color: "#999",
                  fontSize: 15,
                  padding: 15,
                }}
                bold={true}
              >
                {passwordMisMatch}
              </CustomText>
            </View>
          )}
          <Separator />
        </View>
      </View>
    </ScrollView>
  );
};

export default ChangePassword;
